<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
  <path fill="#4562FF" fill-rule="evenodd"
        d="M6 0c.621 0 1.125.46 1.125 1.026v3.848l3.85.001C11.54 4.875 12 5.379 12 6s-.46 1.125-1.026 1.125l-3.849-.001v3.85C7.125 11.541 6.621 12 6 12s-1.125-.46-1.125-1.026v-3.85l-3.85.001C.46 7.125 0 6.621 0 6s.46-1.125 1.026-1.125l3.849-.001V1.026C4.875.459 5.379 0 6 0z"/>
</svg>
